import { DSOptionProps } from '@vr/ds-react'

import { API } from '../api'
import { ProviderLogistic, ProviderLogisticResponse } from './interface'

export const fetch = async (
  term: string = '',
  page: number = 1,
  pageSize: number = 10
): Promise<{
  items: DSOptionProps[]
  total: number
}> => {
  const params: Record<string, string | number> = {
    termo: term,
    pagina: page,
    tamanhoDaPagina: pageSize,
    ordenacao: 'desc'
  }

  try {
    const response = await API.get<ProviderLogisticResponse>(
      '/logistica/filtro/Fornecedor',
      params
    )
    const content = response?.content ?? {}
    const results: ProviderLogistic[] = content ?? []
    const total = content.total ?? 0

    const items: DSOptionProps[] = results.map(account => ({
      label: account.name + ' - ' + account.cnpj,
      value: account.deliverySupplierId
    }))

    return { items, total }
  } catch (error) {
    console.error('Erro ao buscar provedor logistica:', error)
    return { items: [], total: 0 }
  }
}
